export const errorTransformer = (error): string =>
  (error.body?.code && error.body?.cause ? `${error.body.code}. ${error.body.cause}` : null) ||
  error.body?.message ||
  error.body?.cause ||
  error.body?.errors?.join('/n') ||
  error.message ||
  'Something went wrong';
